import { Api } from "../../../../api/Api";
import { GET_ADMIN_USER_API } from "../../../../constants/ApiUrl";

const MakeUserAsBuyerBL = async (props) => {
  const { user, role } = props;

  let success = false;
  let message = "";

  try {
    let path = `${GET_ADMIN_USER_API}/${user._id}/grant/role`;
    const response = await Api(path, { role }, "post");

    if (response.status === 200) {
      message = response.data.responseDescription;
      success = true;
    } else {
      message = response?.data?.responseDescription
        ? response?.data?.responseDescription
        : response?.message;
    }

    // const response = await axiosInstance.post(path, { role });

    // if (response.status == 200) {
    //   message = response.data.responseDescription;
    //   success = true;
    // }
  } catch (err) {
    // Handle Error Here
    // if (err.response) {
    //   message = err.response.data.responseDescription
    //     ? err.response.data.responseDescription
    //     : err.message;
    // }
  }

  return {
    success: success,
    message: message,
  };
};

export default MakeUserAsBuyerBL;
